import { useNavigate } from "react-router-dom";

import { Footer } from "../components/Footer";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="notFoundPageWrapper">
      <div className="content">
        <h5 className="title">Page Not Found</h5>
        <p>The page you&apos;re looking for doesn&apos;t exist.</p>
        <div className="btnContainer">
          <button type="button" onClick={() => navigate("/")}>
            Go Home
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};
